import { render, staticRenderFns } from "./Empresa-tab-faturamento.vue?vue&type=template&id=8a161f58&scoped=true&"
import script from "./Empresa-tab-faturamento.vue?vue&type=script&lang=js&"
export * from "./Empresa-tab-faturamento.vue?vue&type=script&lang=js&"
import style0 from "./Empresa-tab-faturamento.vue?vue&type=style&index=0&id=8a161f58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a161f58",
  null
  
)

export default component.exports